module.exports = __webpack_public_path__ + "dcd9930ca41f428dda0de7368d1f76fa.svg";